import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { AssignPermissionModel } from '../../models/permission.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import { SearchProfileModel } from '../../models/profile.model'

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private baseUrl = environment.baseUrl
  private resource: string = 'gerenciamento-permissao'

  constructor(private httpClient: HttpClient) {}

  public listPermissionProfileId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall/${id}`,
    )
  }

  public listPagedPermissionProfileId(
    page: number,
    rows: number = 15,
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public permissionUserlogged(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/usuario/minhastelas`,
      {
        headers: {  'Content-Type': 'application/json',
        //  "ngrok-skip-browser-warning": "69420"
        }
      },
    )
  }

  public permissionUserId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/telas/usuario/${id}`,
    )
  }

  public listPagedPermissionProfile(
    page: number,
    rows: number = 15,
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/verificar-permissoes/${id}`,
    )
  }

  public searchPagedPermissionProfile(
    page: number,
    rows: number = 15,
    model: SearchProfileModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/telas/perfil/search/?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public assignProfilePermission(
    model: { perfil_id: number | undefined; modulo_id: number; id_crud: number },
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/atribuir-por-crud`,
      model,
    )
  }
  public unassignModulePermission(
    model: { perfil_id: number | undefined; modulo_id: number }
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remover-modulo`,
      {
        body: model
      }
    )
  }

  public assignModulePermission(
    model: { perfil_id: number | undefined; modulo_id: number },
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/atribuir-modulo`,
      model,
    )
  }


  public unassignProfilePermission(
    model: { perfil_id: number | undefined; modulo_id: number; id_cruds: number[] },
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remover-multiplos-cruds`, {
        body: model,
      }
    )
  }
}
